import { CoralogixRum } from '@coralogix/browser'
import moment from 'moment'

export default {
  methods: {
    identifyUser(userData) {
      if (!userData) return
      let fullName = userData.first_name + ' ' + userData.last_name
      try {
        CoralogixRum.setUserContext({
          user_email: userData.email || '',
          user_name: fullName,
          user_id: userData.customer_id
        })
      } catch (error) {
        console.log('Coralogix user identification error:', error)
      }
    },

    orderPlacedEvent() {
      if (!this.orderData) return
      try {
        CoralogixRum.addEvent('Order Placed', {
          orderId: this.orderData.order.order_id,
          customerEmail: this.orderData.customer.email,
          customerFirstName: this.orderData.customer.first_name,
          customerLastName: this.orderData.customer.last_name,
          customerPhone: this.orderData.customer.phone,
          orderTotal: this.orderData.order.charges.total_cents,
          date: moment(this.orderData.order.created_at).format('YYYY-MM-DD'),
          time: moment(this.orderData.order.created_at).format('HH:mm'),
          storeId: this.orderData.restaurant.store_id,
          chainName: this.storeConfig.chain_display_name || '',
        })
      } catch (error) {
        console.log('Coralogix order event error:', error)
      }
    },

    addCustomEvent(eventName, eventData) {
      try {
        CoralogixRum.addEvent(eventName, eventData)
      } catch (error) {
        console.log('Coralogix custom event error:', error)
      }
    },

    addError(error, context = {}) {
      try {
        CoralogixRum.addError(error, context)
      } catch (error) {
        console.log('Coralogix error tracking error:', error)
      }
    },

    setUserIdentity(userId, userData) {
      try {
        CoralogixRum.setUserContext({
          user_id: userId,
          user_email: userData.email || '',
          user_name: userData.displayName || userData.name || ''
        })
      } catch (error) {
        console.log('Coralogix user identity error:', error)
      }
    },

    trackEvent(eventName, eventData) {
      try {
        CoralogixRum.addEvent(eventName, eventData)
      } catch (error) {
        console.log('Coralogix event tracking error:', error)
      }
    },

    trackPageView(pageName, pageData = {}) {
      try {
        CoralogixRum.addEvent('Page View', {
          pageName,
          ...pageData
        })
      } catch (error) {
        console.log('Coralogix page view error:', error)
      }
    }
  },
}
